/** @format */

import React from "react";
import styles from "./style.module.css";
const Footer = () => {
  return <div className={styles.footer}>Made with ❤️‍🔥 by GrayBox</div>;
};
export default Footer;
